// src/subscreens/home/Footer.js
import React, { useState } from 'react';
import { 
  FaFacebook, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn,  // ⬅️ CHANGED from FaLinkedIn
  FaEnvelope, 
  FaPhone, 
  FaMapMarkerAlt,
  FaGraduationCap,
  FaPaperPlane
} from 'react-icons/fa';
import '../../assets/css/general/Footer.css';  // ⬅️ CHANGED to lowercase 'home'

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setTimeout(() => {
        setSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/About' },
    { name: 'IlamAI', path: '/ai' },
    { name: 'Domains', path: '/Domains' },
    { name: 'Contact', path: '/Contact' },
  ];

  const categories = [
    { name: 'Computer Science & IT', path: '/Domains' },
    { name: 'Artificial Intelligence & Data Science', path: '/Domains' },
    { name: 'Business & Management', path: '/Domains' },
    { name: 'Medical & Health Sciences', path: '/Domains' },
    { name: 'Engineering & Technology', path: '/Domains' },
     { name: 'General Education', path: '/Domains' },
  ];

  const socialLinks = [
    { icon: <FaFacebook size={20} />, path: '#', color: '#1877f2' },
    { icon: <FaTwitter size={20} />, path: '#', color: '#1da1f2' },
    { icon: <FaInstagram size={20} />, path: '#', color: '#e4405f' },
    { icon: <FaLinkedinIn size={20} />, path: '#', color: '#0077b5' }  // ⬅️ CHANGED
  ];

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-top">
          <div className="row">
            {/* About Column */}
            <div className="col-lg-3 col-md-6 footer-column">
              <div className="footer-logo">
                <FaGraduationCap className="footer-logo-icon" />
                <span className="footer-logo-text">CircleHub</span>
              </div>
              <p className="footer-tagline">Learn Better, Together</p>
              <p className="footer-description">
                A modern group study platform designed to make learning easier, smarter, and more collaborative for students worldwide.
              </p>
              <div className="social-icons">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index}
                    href={social.path}
                    className="social-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links Column */}
            <div className="col-lg-3 col-md-6 footer-column">
              <h5>Quick Links</h5>
              <ul className="footer-links">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a href={link.path}>{link.name}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Categories Column */}
            <div className="col-lg-3 col-md-6 footer-column">
              <h5>Domains</h5>
              <ul className="footer-links">
                {categories.map((category, index) => (
                  <li key={index}>
                    <a href={category.path}>{category.name}</a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Column */}
            <div className="col-lg-3 col-md-6 footer-column">
              <h5>Contact Us</h5>
              <ul className="contact-info">
                <li>
                  <FaEnvelope className="contact-icon" />
                  <span>support@circlehub.com</span>
                </li>
                <li>
                  <FaPhone className="contact-icon" />
                  <span>+92 300 1234567</span>
                </li>
                <li>
                  <FaMapMarkerAlt className="contact-icon" />
                  <span>Gujranwala, Punjab, Pakistan</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <div className="copyright-text">
              © 2024 CircleHub. All Rights Reserved.
            </div>
            <div className="made-with-love">
              Made with <span className="heart-icon">❤️</span> by Bisma, Nimra & Pakeeza
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
